import { render, staticRenderFns } from "./InputTextareaVertical.vue?vue&type=template&id=4a982eee&scoped=true&lang=pug"
import script from "./InputTextareaVertical.vue?vue&type=script&lang=ts"
export * from "./InputTextareaVertical.vue?vue&type=script&lang=ts"
import style0 from "./InputTextareaVertical.vue?vue&type=style&index=0&id=4a982eee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a982eee",
  null
  
)

export default component.exports